import React from 'react';
import {StyleSheet, View} from 'react-native';

import {space} from '../../../design-system/tokens';
import {STAGGER} from '../constants';
import {Bone} from '../primitives/Bone';
import {BoneButton} from '../primitives/BoneButton';
import {BoneText} from '../primitives/BoneText';
import type {BoneProps} from '../types';

/**
 * The hero omits `height` so `aspectRatio` sizes it; BoneImage's banner height would override the ratio on web.
 * SHORTCUT: BoneProps types `height` as required, so the cast stands in for a type change to the shared
 * primitive. Upgrade path: make `BoneProps.height` optional, then drop the cast.
 */
const heroProps = {
  width: '100%',
  borderRadius: 0,
  style: {aspectRatio: 1.52},
} as unknown as BoneProps;

/**
 * Skeleton for the offer detail screen.
 * Mirrors the offer branch of ExclusiveOfferDetailScreenStandalone: hero image, text card, APPLY button.
 */
export const OfferDetailSkeleton: React.FC = React.memo(() => (
  <View>
    <Bone {...heroProps} animationDelay={STAGGER.delay(0)} />
    <View style={styles.textBlock}>
      <BoneText variant="h1" width="80%" animationDelay={STAGGER.delay(1)} />
      <BoneText variant="body" width="100%" animationDelay={STAGGER.delay(2)} />
      <BoneText variant="body" width="100%" animationDelay={STAGGER.delay(3)} />
      <BoneText variant="body" width="60%" animationDelay={STAGGER.delay(4)} />
    </View>
    <View style={styles.buttonRow}>
      <BoneButton width="80%" animationDelay={STAGGER.delay(5)} />
    </View>
  </View>
));

OfferDetailSkeleton.displayName = 'OfferDetailSkeleton';

const styles = StyleSheet.create({
  textBlock: {
    marginTop: space.s24,
    gap: space.s6,
  },
  buttonRow: {
    alignItems: 'center',
    marginTop: space.s24,
  },
});
